import { units } from '@ui/css';
import { combineTokens, makeScaleableToken } from '@utils/css';

const tokens = combineTokens("--burger", {
  color: "#fff",
  size: [units.px(10), makeScaleableToken]
});
const button = "_ecbnwwnbo";
const burgerCls = "_ecbob87vt";
const lineCls = "_eclprbfob";

/**
 * The top line will translate to center and then disappear when transitioning
 * to cross
 */
const topLineCls = "_ect1yeddix";
const middleLineCls = "_ecmfnq1sp";
const bottomLineCls = "_ecb1iqbkaw";

export { bottomLineCls, burgerCls, button, lineCls, middleLineCls, tokens, topLineCls };
import "./burger.styles.linaria.module.css";
//# sourceMappingURL=burger.styles.js.map
